import { render, staticRenderFns } from "./RelacionarUsuarios.vue?vue&type=template&id=6e6923cc"
import script from "./RelacionarUsuarios.vue?vue&type=script&lang=js"
export * from "./RelacionarUsuarios.vue?vue&type=script&lang=js"
import style0 from "./RelacionarUsuarios.vue?vue&type=style&index=0&id=6e6923cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports